import { Component, Input } from '@angular/core';
import { StatusVariant } from './data-table.model';

/**
 * Soft status pill: coloured text on a pale tinted background.
 * Relies on the global .pill / .pill-{variant} classes in styles.css.
 */
@Component({
  selector: 'app-status-pill',
  template: `<span class="pill pill-{{ variant }}">{{ label }}</span>`,
  standalone: false
})
export class StatusPillComponent {
  @Input() label: string;
  @Input() variant: StatusVariant = 'gray';
}
